module.exports = __webpack_public_path__ + "img/furniture_design.09f227e0.jpg";